import { BaseGetProvider } from "@tendercuts/http";
import { EndPoint } from "./base";
import { Injectable } from "@angular/core";
import { LoginServices } from "./login";
import { HttpClient } from "@angular/common/http";
import { StoreNotification } from '../models';

@Injectable({ providedIn: "root" })
export class FetchStoreNotifications extends BaseGetProvider<StoreNotification> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
    this.delegate = this;
  }

  get isCachable() {
    return false;
  }

  get isAuthenticatedEndpoint() {
    return true;
  }

  get authProtocol() {
    return this.loginService;
  }

  get model() {
    return StoreNotification;
  }

  preProcessResponse(response) {
    return response.results;
  }

  get endpoint() {
    return this.endpointService.storePhoneNumber();
  }

  getParams(storeId: number) {
    let params = {
      store_id: storeId
    }

    return params;
  }
}
